import { IncDataSrcForm } from '@/common/entities/incDataSrc/IncDataSrcForm';
import { IncRuleCardList } from '@/common/entities/incRule/IncRuleCardList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';

export const IncDataSrcDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <IncDataSrcForm /> },
    {
      id: 'incRuleTab',
      label: 'Inclusion Rules',
      content: <IncRuleCardList incDataSrcObj={entityObj} canEdit={entityObj.status !== 'IMPL'} />,
    },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="INC_DATA_SRC" parentEntityObj={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
